"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commonParse = commonParse;
exports.conditionExpressionParse = conditionExpressionParse;
exports.documentationParse = documentationParse;
exports.formatJsonKeyValue = formatJsonKeyValue;
exports.userTaskParse = userTaskParse;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.replace");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function commonParse(element) {
  var result = _objectSpread(_objectSpread({}, element.businessObject), element.businessObject.$attrs);
  return formatJsonKeyValue(result);
}
function formatJsonKeyValue(result) {
  // 移除flowable前缀，格式化数组
  for (var key in result) {
    if (key.indexOf('flowable:') === 0) {
      var newKey = key.replace('flowable:', '');
      result[newKey] = result[key];
      delete result[key];
    }
  }
  result = documentationParse(result);
  return result;
}
function documentationParse(obj) {
  if ('documentation' in obj) {
    var str = '';
    obj.documentation.forEach(function (item) {
      str += item.text;
    });
    obj.documentation = str;
  }
  return obj;
}
function conditionExpressionParse(obj) {
  if ('conditionExpression' in obj) {
    obj.conditionExpression = obj.conditionExpression.body;
  }
  return obj;
}
function userTaskParse(obj) {
  for (var key in obj) {
    if (key === 'candidateUsers') {
      obj.userType = 'candidateUsers';
      obj[key] = obj[key].split(',') || [];
    } else if (key === 'candidateGroups') {
      obj.userType = 'candidateGroups';
      obj[key] = obj[key].split(',') || [];
    } else if (key === 'assignee') {
      obj.userType = 'assignee';
    }
  }
  return obj;
}